/*
  Real counts for the budget pills in the collection header.

  The counts used to be typed in by hand and were the same on every collection,
  so they were wrong nearly everywhere. They cannot be worked out in Liquid
  either - outside a paginate loop only 50 of a collection's products are
  exposed, so any computed figure would be silently wrong on a large collection.

  Instead each pill's own filtered URL is fetched and the result count read from
  the [data-product-count] element the facets markup already renders. Requests
  ask for section_id so Shopify returns just the product-grid section rather
  than a whole page, and answers are cached per URL for the tab's session.
*/
(function () {
  var NOUN = 'hampers';

  function label(n) {
    return n + ' ' + (n === 1 ? NOUN.replace(/s$/, '') : NOUN);
  }

  function cacheGet(key) {
    try {
      var v = sessionStorage.getItem(key);
      return v === null ? null : parseInt(v, 10);
    } catch (e) {
      return null;
    }
  }

  function cacheSet(key, n) {
    try {
      sessionStorage.setItem(key, String(n));
    } catch (e) {}
  }

  function render(pill, n) {
    if (isNaN(n)) return;
    var el = pill.querySelector('.pv-col-header__pill-count');
    if (!el) {
      el = document.createElement('span');
      el.className = 'pv-col-header__pill-count';
      pill.appendChild(el);
    }
    el.textContent = label(n);
  }

  function run() {
    var pills = document.querySelectorAll('.pv-col-header__pill[href*="filter.v.price"]');
    if (!pills.length) return;

    var grid = document.getElementById('product-grid');
    var sectionId = grid ? grid.getAttribute('data-id') : null;

    Array.prototype.forEach.call(pills, function (pill) {
      var href = pill.getAttribute('href');
      if (!href) return;

      var cached = cacheGet('pvPill:' + href);
      if (cached !== null) {
        render(pill, cached);
        return;
      }

      var url = href;
      if (sectionId) url += (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

      fetch(url)
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-product-count]');
          if (!el) return;
          var n = parseInt(el.getAttribute('data-product-count'), 10);
          if (isNaN(n)) return;
          cacheSet('pvPill:' + href, n);
          render(pill, n);
        })
        .catch(function () {
          // Leave the pill without a count rather than showing a wrong one.
        });
    });
  }

  function start() {
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2000 });
    else setTimeout(run, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
